import Nullstack from 'nullstack';
export default function IconHelicopter({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-helicopter",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 10l1 2h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "9",
    x2: "13",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "6",
    x2: "20",
    y2: "6"
  }), "   ", Nullstack.element("path", {
    d: "M15 9.1v3.9h5.5"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "19",
    x2: "15",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "19",
    x2: "11",
    y2: "19"
  }), " ");
}